export default "__VITE_ASSET__529acb7c__"